// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sqmm","questions":"styles_questions__Cor8G","footer":"styles_footer__1GmwE"};